import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/ChangePasswordView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    component: () => import('@/layouts/FactoryLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
      { path: 'orders', name: 'orders', component: () => import('@/views/OrderView.vue') },
      { path: 'production', name: 'production', component: () => import('@/views/ProductionView.vue') },
      { path: 'print-tasks', name: 'print-tasks', component: () => import('@/views/PrintTaskView.vue') },
      { path: 'pricing', name: 'pricing', component: () => import('@/views/PricingView.vue') },
      { path: 'statement', name: 'statement', component: () => import('@/views/StatementView.vue') },
      { path: 'devices', name: 'devices', component: () => import('@/views/DeviceView.vue') },
      { path: 'settings', name: 'settings', component: () => import('@/views/SettingsView.vue') }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth !== false && !authStore.isLoggedIn) {
    next('/login')
    return
  }

  if (to.path === '/login' && authStore.isLoggedIn) {
    if (authStore.mustChangePassword) {
      next('/change-password')
    } else {
      next('/')
    }
    return
  }

  if (authStore.isLoggedIn && authStore.mustChangePassword && to.name !== 'change-password') {
    next('/change-password')
    return
  }

  next()
})

export default router
